<template>
  <div class="purchased-courses" dir="rtl">
    <div class="container">
      <!-- Header Section -->
      <header class="header">
        <h1 class="page-title">الكورسات المشتراة</h1>
        <p class="page-subtitle">عرض جميع الكورسات المشتراة مع معلومات المشترين</p>
      </header>

      <!-- Table Container -->
      <div class="table-container">
        <div class="table-header">
          <h2 class="table-title">قائمة الكورسات المشتراة</h2>
        </div>

        <!-- Table -->
        <div class="table-responsive">
          <table class="courses-table table table-striped table-hover table-sm">
            <thead>
              <tr>
                <th>التسلسل</th>
                <th>صورة الكورس</th>
                <th>عنوان الكورس</th>
                <th>اسم المشتري</th>
                <th>البريد الإلكتروني</th>
                <th>رقم الهاتف</th>
                <th>النقاط</th>
                <th>تاريخ الشراء</th>
                <th>الحالة</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(course, index) in list" :key="index">
                <td>{{ (pageNumber - 1) * pageSize + (index + 1) }}</td>
                <td>
                  <img 
                    v-if="course.courseCoverPhotoUrl" 
                    :src="course.courseCoverPhotoUrl" 
                    alt="صورة الكورس"
                    class="course-image"
                  />
                  <span v-else>لا توجد صورة</span>
                </td>
                <td>{{ course.courseTitle || 'غير محدد' }}</td>
                <td>{{ course.userFullName || 'غير محدد' }}</td>
                <td>{{ course.userEmail || 'غير محدد' }}</td>
                <td>{{ course.userPhoneNumber || 'غير محدد' }}</td>
                <td>{{ course.coursePoint }} نقطة</td>
                <td>{{ formatDate(course.purchaseDate) }}</td>
                <td>
                  <span 
                    :class="{
                      'badge-success': !course.isCancelled, 
                      'badge-danger': course.isCancelled
                    }"
                    class="status-badge"
                  >
                    {{ course.isCancelled ? 'ملغي' : 'نشط' }}
                  </span>
                </td>
              </tr>

              <!-- Empty State -->
              <tr v-if="list.length === 0">
                <td colspan="9" class="empty-state">
                  <div class="empty-icon">📚</div>
                  <h3>لا توجد كورسات مشتراة</h3>
                </td>
              </tr>
            </tbody>
          </table>
        </div>

        <!-- Pagination -->
        <div class="pagination-container">
          <custom-pagination
            :currentPage="pageNumber"
            :totalPages="totalPages"
            @page-changed="handlePageChange"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import apiClient from "@/api";
import CustomPagination from "@/components/CustomPagination.vue";
import Swal from "sweetalert2";

export default {
  name: "PurchasedCoursesPage",
  components: { CustomPagination },
  data() {
    return {
      list: [],
      pageNumber: 1,
      pageSize: 10,
      totalPages: 1,
    };
  },
  methods: {
    async getPurchasedCourses() {
      try {
        const response = await apiClient.get("/api/UserCourse/GetPurchasedCoursesWithDetails", {
          params: { 
            PageNumber: this.pageNumber, 
            PageSize: this.pageSize 
          },
        });
        this.list = response.data.items || [];
        this.pageNumber = response.data.pageNumber || 1;
        this.totalPages = response.data.totalPages || 1;
      } catch (error) {
        console.error("حدث خطأ أثناء جلب البيانات", error);
        Swal.fire({
          icon: "error",
          title: "خطأ",
          text: "حدث خطأ أثناء جلب البيانات",
          timer: 3000,
          showConfirmButton: false,
        });
      }
    },
    formatDate(date) {
      if (!date) return "غير محدد";
      return new Date(date).toLocaleDateString("ar-EG", {
        year: "numeric",
        month: "2-digit",
        day: "2-digit",
      });
    },
    handlePageChange(pageNumber) {
      this.pageNumber = pageNumber;
      this.getPurchasedCourses();
    },
  },
  mounted() {
    this.getPurchasedCourses();
  },
};
</script>

<style scoped>
.purchased-courses {
  min-height: 100vh;
  background: linear-gradient(135deg, #f8f9fa 0%, #e9ecef 100%);
  padding: 2rem;
}

.container {
  max-width: 1400px;
  margin: 0 auto;
}

.header {
  text-align: center;
  margin-bottom: 2rem;
  padding: 2rem;
  background: white;
  border-radius: 12px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
}

.page-title {
  font-size: 2rem;
  color: #002f49;
  margin-bottom: 0.5rem;
  font-weight: 600;
}

.page-subtitle {
  color: #666;
  font-size: 1rem;
}

.table-container {
  background: white;
  border-radius: 12px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  padding: 1.5rem;
}

.table-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 1.5rem;
  padding-bottom: 1rem;
  border-bottom: 2px solid #e9ecef;
}

.table-title {
  font-size: 1.5rem;
  color: #002f49;
  font-weight: 600;
}

.table-responsive {
  overflow-x: auto;
}

.courses-table {
  width: 100%;
  margin-bottom: 0;
}

.courses-table thead th {
  background-color: #002f49;
  color: white;
  font-weight: 600;
  padding: 1rem;
  text-align: center;
  border: none;
}

.courses-table tbody td {
  padding: 1rem;
  text-align: center;
  vertical-align: middle;
  border-bottom: 1px solid #e9ecef;
}

.course-image {
  width: 60px;
  height: 60px;
  object-fit: cover;
  border-radius: 8px;
}

.status-badge {
  padding: 0.4rem 0.8rem;
  border-radius: 20px;
  font-size: 0.85rem;
  font-weight: 600;
}

.badge-success {
  background-color: #d4edda;
  color: #155724;
}

.badge-danger {
  background-color: #f8d7da;
  color: #721c24;
}

.action-buttons {
  display: flex;
  gap: 0.5rem;
  justify-content: center;
}

.btn {
  padding: 0.4rem 0.8rem;
  border: none;
  border-radius: 6px;
  cursor: pointer;
  font-size: 0.85rem;
  transition: all 0.3s;
}

.btn-info {
  background-color: #17a2b8;
  color: white;
}

.btn-info:hover {
  background-color: #138496;
}

.btn-danger {
  background-color: #dc3545;
  color: white;
}

.btn-danger:hover {
  background-color: #c82333;
}

.btn-success {
  background-color: #28a745;
  color: white;
}

.btn-success:hover {
  background-color: #218838;
}

.btn-sm {
  padding: 0.3rem 0.6rem;
  font-size: 0.8rem;
}

.empty-state {
  text-align: center;
  padding: 3rem;
  color: #666;
}

.empty-icon {
  font-size: 4rem;
  margin-bottom: 1rem;
}

.pagination-container {
  margin-top: 2rem;
  display: flex;
  justify-content: center;
}

@media (max-width: 768px) {
  .purchased-courses {
    padding: 1rem;
  }

  .courses-table {
    font-size: 0.85rem;
  }

  .course-image {
    width: 40px;
    height: 40px;
  }

  .action-buttons {
    flex-direction: column;
  }
}
</style>

